import React from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getWatchlist, removeWatch, fmtPrice } from "@/lib/api";
import { Star, X, ArrowUp, ArrowDown } from "lucide-react";
import { Sparkline } from "@/components/Sparkline";

export const Watchlist = ({ onSelect }) => {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ["watchlist"], queryFn: getWatchlist, refetchInterval: 15000 });
  const rm = useMutation({
    mutationFn: removeWatch,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["watchlist"] }),
  });

  return (
    <div className="bg-surface border border-border rounded-lg overflow-hidden" data-testid="watchlist-panel">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-border bg-app/60">
        <Star size={15} className="text-warn" />
        <h3 className="text-sm font-semibold uppercase tracking-[0.1em] text-white">Watchlist</h3>
        <span className="text-[10px] font-mono text-tertiary">({data.length})</span>
      </div>
      {!data.length && (
        <div className="text-center py-10 text-tertiary font-mono text-xs px-4">
          Star tickers in the scanner to track them here.
        </div>
      )}
      {data.map((s) => {
        const up = s.change_pct >= 0;
        return (
          <div key={s.symbol} data-testid={`watch-row-${s.symbol}`} onClick={() => onSelect(s.symbol)}
            className="flex items-center gap-3 px-4 py-3 border-b border-border-subtle hover:bg-surface-2 cursor-pointer transition-colors group">
            <div className="flex-1 min-w-0">
              <div className="font-mono font-bold text-white">{s.symbol}</div>
              <div className="text-[10px] text-tertiary truncate">{s.name}</div>
            </div>
            <div className="w-16 hidden sm:block"><Sparkline data={s.spark} up={up} height={28} /></div>
            <div className="text-right">
              <div className="font-mono text-white text-sm">${fmtPrice(s.price)}</div>
              <div className={`font-mono text-xs flex items-center justify-end gap-0.5 ${up ? "text-bull" : "text-bear"}`}>
                {up ? <ArrowUp size={10} /> : <ArrowDown size={10} />}{up ? "+" : ""}{s.change_pct}%
              </div>
            </div>
            <button data-testid={`unwatch-${s.symbol}`} onClick={(e) => { e.stopPropagation(); rm.mutate(s.symbol); }}
              className="opacity-30 group-hover:opacity-100 text-tertiary hover:text-bear transition-all">
              <X size={15} />
            </button>
          </div>
        );
      })}
    </div>
  );
};
